export default [
    {
        id: 1,
        name: 'Combustible'
    },
    {
        id: 2,
        name: 'Peajes'
    },
    {
        id: 3,
        name: 'Viaticos'
    }
]
